import React from 'react';
import { Redirect } from 'expo-router';

// REQUEST/chat de negociação de recorrência desativado no front por ora.
// Tela original preservada abaixo para reativar depois.
// Ao reativar: "Denunciar" e "Bloquear" no cabeçalho são obrigatórios na App
// Store (1.2) — a API já tem POST conversations/:id/report e /block.
export default function ProviderChatThreadScreen() {
  return <Redirect href="/(tabs)/(provider)/schedule" />;
}

/*
import { Pressable, View } from 'react-native';
import { router, useLocalSearchParams } from 'expo-router';

import { ThemedText } from '@/components/themed-text';
import { DetailHeader } from '@/components/ui/detail-header';
import { ChatThread } from '@/components/schedule/chat-thread';
import {
  useAcceptConversation,
  useDeclineConversation,
} from '@/hooks/use-recurrence-chat';
import { MESSAGE_SENDER } from '@/types/message-sender';
import { useToastStore } from '@/store/toastStore';
import { useThemedHex } from '@/hooks/use-theme-colors';

export default function ProviderChatThreadScreen() {
  const th = useThemedHex();
  const { id } = useLocalSearchParams<{ id: string }>();
  const accept = useAcceptConversation();
  const decline = useDeclineConversation();
  const { addToast } = useToastStore();
  const busy = accept.isPending || decline.isPending;

  const onAccept = () =>
    id &&
    accept.mutate(id, {
      onSuccess: () => addToast('Recorrência criada e ativada.', 'success'),
      onError: () => addToast('Falha ao aceitar.', 'error'),
    });
  const onDecline = () =>
    id &&
    decline.mutate(id, {
      onSuccess: () => addToast('Negociação recusada.', 'success'),
      onError: () => addToast('Falha ao recusar.', 'error'),
    });

  return (
    <View style={{ flex: 1, backgroundColor: th('#fff') }}>
      <DetailHeader title="Negociação" onBack={() => router.back()} />
      {id ? (
        <ChatThread conversationId={id} viewerRole={MESSAGE_SENDER.PROVIDER} />
      ) : null}
      <View
        style={{
          flexDirection: 'row',
          gap: 10,
          padding: 12,
          borderTopWidth: 1,
          borderTopColor: th('#e5e7eb'),
        }}
      >
        <Pressable
          onPress={onAccept}
          disabled={busy}
          style={{
            flex: 1,
            backgroundColor: '#059669',
            borderRadius: 999,
            paddingVertical: 12,
            alignItems: 'center',
            opacity: busy ? 0.5 : 1,
          }}
        >
          <ThemedText style={{ color: '#fff', fontWeight: '600' }}>
            Aceitar e criar recorrência
          </ThemedText>
        </Pressable>
        <Pressable
          onPress={onDecline}
          disabled={busy}
          style={{
            backgroundColor: th('#f3f4f6'),
            borderRadius: 999,
            paddingVertical: 12,
            paddingHorizontal: 18,
            alignItems: 'center',
            opacity: busy ? 0.5 : 1,
          }}
        >
          <ThemedText style={{ color: '#dc2626', fontWeight: '600' }}>
            Recusar
          </ThemedText>
        </Pressable>
      </View>
    </View>
  );
}
*/
